module.exports = {
  Beginner:'အခြေခံ',
  BeginnerTips1:'ပင်ယင်းအသံများနှင့် သံများကို ကြည့်ပြီး လေ့လာပါ။',
  BeginnerTips2:'ပင်ယင်း အသံများနှင့် သံများ',
  Intermediate:'အလယ်အလတ်',
  IntermediateTips1:'အသံထွက်ထွက်လွှတ်မှုနှင့် သဒ္ဒါကျွမ်းကျင်မှုများကို မြှင့်တင်ပါ။',
  Advanced:'အဆင့်မြင့်',
  AdvancedTips1:'ပြောဆိုနိုင်စွမ်း၊ ထုတ်ဖော်ဖော်ပြနိုင်စွမ်း နှင့် သဘာဝကျသော စကားပြောစွမ်းအားကို တိုးမြှင့်ပါ။',
  AdvancedTips2:'စကားပြော ဗီဒီယို စာရင်း',
  '300 Sentences':'၃၀၀ စာကြောင်း',
  '300SentencesTips1':'ဘဝ၊ သင်ကြားမှုနှင့် ခရီးသွားမှုအတွက် အသုံးဝင်သော တရုတ်စာကြောင်း ၃၀၀ ခု။',
  'Basic Challenge':'အခြေခံ စိန်ခေါ်မှု',
  'Basic Chinese Challenge':'အခြေခံတရုတ်စာ စိန်ခေါ်မှု',
  'BasicChallengeTips1':'သံထွက်၊ ပင်ယင်းကို စမ်းသပ်ပါ။',
  ChallengeTips:'မဖွင့်ရသေးပါ',
  'Learn':'လေ့လာပါ',
  'Watch':'ကြည့်ပါ',
  'Recommended':'အကြံပြုထားသည်',
  NoGameList:'အခြေခံ စိန်ခေါ်မှု မရှိပါ!',
  "Sample Sentence":"နမူနာ စာကြောင်း",
  "Ques No":"မေးခွန်း အမှတ်",
  "Correct Answer":"မှန်ကန်သော အဖြေ",
  "Your Answer":"သင့်အဖြေ",
  "Your Result":"သင့်ရလဒ်",
  "Final Result":"အဆုံးအဖြတ်",
  "Previous":"ယခင်",
  "Next":"နောက်",
  "Try Again":"ထပ်ကြိုးစားပါ",
  "Next Level":"နောက်အဆင့်",
  "Profile":"ပရိုဖိုင်",
  "Current Challenge Level":"လက်ရှိ စိန်ခေါ်မှု အဆင့်",
  language:"ဘာသာစကားရွေးချယ်ရန်",
  Unsucscribe:"စာရင်းဖျက်ရန်",
  back:"နောက်သို့",
  Replay:"ပြန်ဖွင့်မည်",  // (သို့မဟုတ် "ပြန်ဖွင့်ရန်")
  English:"အင်္ဂလိပ်",
  loginTips:"ဖုန်းနံပါတ်ထည့်ပါ",
  subscribe:'စာရင်းသွင်းပါ',
  FAQ:"မေးလေ့ရှိသော မေးခွန်းများ",
  TC:"စည်းမျဉ်းစည်းကမ်းများ",
  getCode:"ထပ်ပို့ရန်",
  register:"စာရင်းသွင်းရန်",
  phoneNumber:"ဖုန်းနံပါတ်",
  Daily:"နေ့စဉ်",
  Weekly:"အပတ်စဉ်",
  pleaseWait:"ကျေးဇူးပြုပြီး စောင့်ပါ",
  loading:"တင်နေသည်",
  Submit:"တင်သွင်းရန်",
  Confirm:"အတည်ပြုရန်",
  OK:"အိုကေ",
  change:"ပြောင်းရန်",
  Myanmar:"မြန်မာ",
  Copyright:"© 2025 မူပိုင်ခွင့် အားလုံး ထားရှိသည်။",
  select_level: "သုံးသပ်ချက်စတင်ပါ",
  select_level_tip1: "ယခုစတင်ပါ",
  select_level_tip2: "ကျော်မည်",
  level_1_title: "မင်းရဲ့လေ့လာမှုခရီးစဉ်က ဒီကနေစပါတယ်",
  level_1_tip: "သင့်ရဲ့လေ့လာမှုအဆင့်က စတင်လေ့လာသူအဆင့်ဖြစ်ပါတယ်။ ဘာသာစကားအတွက် အုတ်မြစ်ခိုင်ခိုင်မာမာကို ဒီအဆင့်မှာ တည်ဆောက်နိုင်ပါတယ်။",
  level_1_btn: "ခရီးစဉ်စတင်မယ်",
  level_2_title: "တိုးတက်မှုကောင်းလိုက်တာ",
  level_2_tip: "သင့်ရဲ့လေ့လာမှုအဆင့်က အလယ်အလတ်တန်းအဆင့်ကို ရောက်ရှိသွားပါပြီ။ စကားပြောတွေ၊ သဒ္ဒါတွေ၊ ကျွမ်းကျင်ပိုင်နိုင်မှုတွေကို မြှင့်တင်ဖို့ အချိန်တန်ပါပြီ။",
  level_2_btn: "ဆက်လက်သင်ယူမယ်",
  level_3_title: "အထင်ကြီးစရာ ကျွမ်းကျင်မှုတွေပါလား",
  level_3_tip: "သင့်ရဲ့လေ့လာမှုအဆင့်က အဆင့်မြင့်အဆင့်ဖြစ်ပါတယ်။ တရုတ်လူမျိုးတစ်ယောက်လို စကားပြောဆိုနိုင်မှုနဲ့ နားလည်နိုင်မှုကို ကျွမ်းကျင်အောင်လုပ်ဆောင်ဖို့ အဆင်သင့်ဖြစ်နေပါပြီ။",
  level_3_btn: "ကျွမ်းကျင်မှုစတင်မယ်",
  level_again: "လေ့လာမှုအဆင့် ပြန်သတ်မှတ်မယ်",
  current_level: "လက်ရှိလေ့လာမှုအဆင့်",
  Re_admission: "ပညာသင်ခွင့် ပြန်လျှောက်ထားခြင်း",
  Re_testing: " ပြန်လည်လေ့ကျင့်ခြင်း",
  Intermediate_tips:"ကျေးဇူးပြု၍ အခြေခံကို အရင်ပြီးအောင်သင်ယူပါ",
  Advanced_tips:"ကျေးဇူးပြု၍ အလယ်အလတ်သင်ယူမှုကို အရင်ပြီးအောင်လုပ်ပါ",
  in_process:"လုပ်ဆောင်ဆဲ",
  no_start:"မစသေးပါ",
  finished:"ပြီးဆုံးပြီ",
  books:"စာအုပ်များ",
  guidance:"လမ်းညွှန်ချက်",
  test_level_tip:"သင့်ဘာသာစကားအဆင့်ကို သိရှိရန် အတိုချုံးစစ်ဆေးခြင်း ပြုလုပ်ပါ။",
  beginner_guidance_title:"အခြေခံအတန်းမှ ကြိုဆိုပါတယ်",
  beginner_guidance_tip:"ပင်ယင်းကနေ စတင်သင်ကြားပေးသွားမှာဖြစ်ပြီး ပင်ယင်း သင်ခန်းစာပြီးဆုံးပါက ပိုမိုစိတ်ဝင်စားဖွယ် သင်ခန်းစာများကို အလိုအလျောက် ဖွင့်ပေးသွားမှာဖြစ်ပါတယ်။",
  intermediate_guidance_title:"အလယ်အတန်းမှ ကြိုဆိုပါတယ်",
  intermediate_guidance_tip:"စိတ်မပူပါနဲ့။ အဆင့်ဆင့် သင်ယူနိုင်ပါတယ်။ သင်ခန်းစာအားလုံး ပြီးဆုံးအောင်လုပ်ဆောင်ပါက ပိုမိုစိတ်ဝင်စားဖွယ်ကောင်းတဲ့ အတန်းများကို ရရှိမှာဖြစ်ပါတယ်။ ဆက်လက်အားထုတ်ပါ။",
  advance_guidance_title:"အဆင့်မြင့်အတန်းမှ ကြိုဆိုပါတယ်",
  advance_guidance_tip:"သင်ခန်းစာအားလုံးကို ဖွင့်ပေးထားပြီးဖြစ်ပါတယ်။ ပြည့်ဝစွာ သင်ယူပါ။",
  book_title:"သင့်တော်သောစာအုပ်များ" ,
  book_tip:"အဆင့်မရွေး၊ လွယ်ကူစွာ သင်ယူနိုင်ပြီး ပျော်စရာ စာအုပ်မျာ!" ,
  load_book: "စာအုပ်မှအကြောင်းအရာများ  ပြင်ဆင်နေပါသည်...",
  load_book_failed: "စာအုပ်မှအကြောင်းအရာများ ပြင်ဆင်မှုမအောင်မြင်ပါ",
  reload: "ပြန်လည်လုပ်ဆောင်မည်",
  copyLink:'လင့်ခ်ကိုကူးယူပါ။',
  downTips1:'ကျေးဇူးပြု၍ လင့်ခ်ကို browser ထဲသို့ ကူးယူပြီး ဒေါင်းလုဒ်လုပ်ပါ။',
  CopySucceeded:'ကော်ပီ အောင်မြင်သွားပြီ',
  CopyFailed:'ကော်ပီ မအောင်မြင်ပါ။',
  sub_type:"စာရင်းသွင်းထားသောအမျိုးအစား",
  test_tip:"ကျေးဇူးပြု၍ အဖြေမှန်ကို နှိပ်ပါ။",
  English_tip:"မြန်မာ",
  Background_Music:"နောက်ခံသီချင်း",
  loadMore2:"စာအုပ်တွေ မရှိတော့ဘူး",
  all_categories:"အမျိုးအစားအားလုံး",
  select_pick_tip:"ဘာသာစကားတစ်ခုရွေးချယ်ပြီး ဒီနေ့ပဲ စတင်လိုက်ပါ!",
  Selected:"ရွေးချယ်ထားသော",
  Chinese:"တရုတ်",
  book_voice_label:"အသံ",
  no_voice_tip:"ဒီစာမျက်နှာအတွက် အသံမရှိပါ",
}



// WEBPACK FOOTER //
// ./src/assets/i18n/bur.js